import React from 'react'
import { useInView } from 'react-intersection-observer'
import { graphql } from 'gatsby'

import * as styles from './map.module.scss'

import StructuredTextDefault from '@/components/structured-text/structured-text-default'

const MapBlock = (props) => {
  const { content, image } = props
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  })
  return (
    <div
      ref={ref}
      className={`col-lg-6 animated ${inView ? 'start-animation' : ''} pb-big`}
    >
      <div
        className={styles.bgImage}
        style={{ backgroundImage: `url(${image.url})` }}
      >
        <StructuredTextDefault content={content} />
      </div>
    </div>
  )
}

export default MapBlock

export const query = graphql`
  fragment SectionMap on DatoCmsMap {
    content {
      value
    }
    image {
      url
    }
  }
`
